import axios from 'axios';
import cookies from 'vue-js-cookie';
import router from '@/router/index';
import i18n from '@/languages';
import AppHelper from "../helper";

//TODO: verify if can be replace by Vue Plugin
export default class Api {

    constructor(apiURL) {
        this.apiURL = apiURL;
        this.initAPIConnector();
    }

    initAPIConnector() {
        var instance = this;

        this.apiConnector = axios.create({
            baseURL: instance.apiURL,
            method: 'post',
            withCredentials: true,
            // Prepares request data as form data
            transformRequest: [
                (data, headers) => {
                    var formData = new FormData();
                    for(var key in data){
                        var value = data[key];
                        if(typeof value === 'object'){
                            value = JSON.stringify(value);
                        }
                        formData.set(key, value);
                    }

                    return formData;
                },
            ],
            // Convert response data to json
            transformResponse: [
                (data) => {
                    try{
                        if(!(data instanceof ArrayBuffer)){
                            data = JSON.parse(data);
                        }
                    }
                    catch(err){
                        if(process.env != 'production'){
                            console.log(err);
                        }
                    }

                    return data;
                }
            ]
        });

        this.apiConnector.interceptors.response.use(function (response) {
            if(response.data.success){
                if(!AppHelper.empty(response.data.result)){
                    var result = response.data.result;
                    if(!AppHelper.empty(result.accessKey)){
                        cookies.remove('accessKey');
                        cookies.set('accessKey', result.accessKey);

                    }
                    if(!AppHelper.empty(result.crmid)){
                        cookies.remove('crmid');
                        cookies.set('crmid', result.crmid);
                    }
                }
            }
            else if(!AppHelper.empty(response.data.error)){
                // If authentification failed redirects to login page
                response.data.error['label'] = instance.getErrorLabel(response.data.error.code);

                if(response.data.error.code == 604){
                    instance.clearCookies()
                    router.push({name: 'Login'})
                }
                else if(response.data.error.code == 601 || response.data.error.code == 602){
                    AppHelper.notify(response.data.error.label, 'error')
                }
            }

            return response.data;
        });

        this.apiConnector.interceptors.request.use(function (request) {
            // Appends common request data for api operations
            if(!request.ignoreDefaultParams){
                request.data['key'] = cookies.get('accessKey')
                request.data['gdpr_record_crmid'] = cookies.get('crmid')
            }

            request.data['height'] = window.screen.availHeight
            request.data['width'] = window.screen.availWidth

            return request;
        });
    }

    getErrorLabel(code) {
        switch (code){
            case 601:
            case 602:
            default:
                return i18n.t('LBL_SYSTEM_ERROR');
                break;
            case 603:
                return i18n.t('LBL_PORTAL_ACCESS_REFUSED');
                break;
            case 604:
            case 605:
                return i18n.t('LBL_LOGIN_ERROR');
                break;
            case 606:
                return i18n.t('LBL_EMAIL_IS_NOT_REGISTERED');
                break;
            case 607:
            case 608:
                return i18n.t('LBL_CREDENTIALS_ALREADY_EXIST');
                break;
        }
    }

    static getInstance() {
        if(this.instance == null){
            this.instance = new Api();
        }

        return this.instance;
    }

    clearCookies() {
        cookies.remove('accessKey');
        cookies.remove('crmid');
    }

    async logout() {
        this.clearCookies();
        return await this.apiConnector({data: {'operation': 'logout'}});
    }

    async login(email, password) {
        var data = {
            'operation': 'login',
            'gdpr_email': email,
            'gdpr_password': password,
            'gdpr_instance_key': cookies.get('instance')
        };

        return await this.apiConnector({data: data, ignoreDefaultParams: true});
    }

    isAuthenticated() {
        if(AppHelper.empty(cookies.get('accessKey')) && AppHelper.empty(cookies.get('crmid'))){
            return false;
        }

        return true;
    }

    async fetchStructure() {
        return await this.apiConnector({data: {'operation': 'fetch_structure'}});
    }

    async resetPassword(email){
        var data = {
            'operation': 'reset_password',
            'gdpr_email': email,
            'gdpr_instance_key': cookies.get('instance')
        }

        return await this.apiConnector({data: data, ignoreDefaultParams: true});
    }

    async requestAccess(email){
        var data = {
            'operation': 'request_access',
            'gdpr_email': email,
            'gdpr_instance_key': cookies.get('instance')
        }

        return await this.apiConnector({data: data, ignoreDefaultParams: true});
    }

    async update(data) {
        return await this.apiConnector({data: {'operation': 'update', 'updated_fields': data}});
    }

    async export() {
        return await this.apiConnector({data: {'operation': 'export'}});
    }

    async forgetMe() {
        return await this.apiConnector({data: {'operation': 'forget_me'}});
    }

    async download(fileId) {
        var data = {
            'operation': 'download',
            'file_id': fileId
        }

        return await this.apiConnector({data: data, responseType: 'blob'});
    }

    async getLoginMessage() {
        var data = {
            'operation': 'get_login_message',
            'gdpr_instance_key': cookies.get('instance'),
        }

        return await this.apiConnector({data: data, ignoreDefaultParams: true});
    }
}


// WEBPACK FOOTER //
// ./src/api/index.js